import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'; // Import Router components
import './App.css';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';
import Header from './components/Header';
import HeroSection from './components/HeroSection';

function App() {
  return (
    <Router> {/* Wrap the entire app with Router */}
      <div className="App">
        <Header />
        <div style={{ paddingTop: '5rem' }}>
          <Routes> {/* Define routes */}
            <Route path="/" element={
              <>
                <HeroSection />
                {/* Placeholder sections for product features */}
                {/* <ProductFeatureSection
                  title="Product Feature 1"
                  description="Engaging description of the first key feature. Explain how it benefits the user and solves a problem. Keep it concise and impactful."
                  // imageUrl="placeholder1.jpg" // Replace with actual image path or URL
                  imageAlt="Description of feature 1 image"
                />
                <ProductFeatureSection
                  title="Product Feature 2"
                  description="Detailed explanation of the second amazing feature. Highlight its unique selling points and how it stands out from competitors."
                  // imageUrl="placeholder2.jpg" // Replace with actual image path or URL
                  imageAlt="Description of feature 2 image"
                  reverseLayout={true} // This will alternate the layout
                />
                <ProductFeatureSection
                  title="Product Feature 3"
                  description="Compelling overview of the third essential feature. Focus on the value it provides and encourage users to learn more or try it out."
                  // imageUrl="placeholder3.jpg" // Replace with actual image path or URL
                  imageAlt="Description of feature 3 image"
                /> */}
                <FeaturesSection />
              </>
            } />
            {/* Add other routes here for /for-teachers, /for-schools, /pricing */}
            {/* Example: <Route path="/for-teachers" element={<ForTeachersPage />} /> */}
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
